import ModelViewer from './components/ModelViewer'
export default function App (){
  return (
    <ModelViewer />
  )
}

// 1. master分支 ===>  master_名字_功能_日期 ===> 测试服务器 ===> 测试完成 ===> 名字_功能_日期 ===> 合并到master分支

